import { createRouter,createWebHistory } from "vue-router";
import organization from "@/router/organization";
import win from "@/router/win";
import ihaogu from "@/router/ihaogu";
import school from "@/router/school";
import report from "@/router/report";
import jfcap from "@/router/jfcap";
import team from "@/router/team";
import jftech from "@/router/jftech";
const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: "/login",
        name: "login",
        meta: {
            title: '登录页面'
        },
        component: () =>
            import("@/components/admin/login/AdminLogin.vue")
    },
    {
        path: "/wx_login",
        name: "wx_login",
        meta: {
            title: '扫码登录'
        },
        component: () =>
            import("@/components/admin/login/WxLogin.vue")
    },
    {
        path: "/logout",
        name: "logout",
        meta: {
            title: '登出'
        },
        component: () =>
            import("@/components/admin/login/AdminLogout.vue")
    },
    {
        path: "/login/auth",
        name: "login_auth",
        meta: {
            title: '登录页面'
        },
        component: () =>
            import("@/components/admin/login/AdminAuth.vue")
    },
    {
        path: "/business/auth",
        name: "business_auth",
        meta: {
            title: '登录页面'
        },
        component: () =>
            import("@/components/admin/login/AdminBusinessAuth.vue")
    },
    {
        path: "/msg",
        name: "msg",
        meta: {
            title: '提示信息',
            mustLogin: true
        },
        component: () =>
            import("@/components/admin/login/AdminMsg.vue")
    },
    {
        path: "/register",
        name: "register",
        meta: {
            title: '注册页面',
            mustLogin: true
        },
        component: () =>
            import("@/components/admin/login/AdminRegister.vue")
    },
    {
        path: "/home",
        name: "home",
        meta: {
            title: '文章管理系统',
            mustLogin: true
        },
        component: () =>
            import("@/layout/admin/AdminHome"),
        children: [
            {
                path: '/welcome',
                name: 'welcome',
                component: function () {
                    return import('@/components/admin/Welcome')
                }
            },
            {
                path: '/dialog/picture',
                name: 'SelectPicture',
                component: function () {
                    return import('@/components/dialog/SelectPicture')
                }
            },
            {
                path: '/dialog/article',
                name: 'SelectArticle',
                component: function () {
                    return import('@/components/dialog/SelectArticle')
                }
            },
            {
                path: '/dialog/win/article',
                name: 'SelectWinArticle',
                component: function () {
                    return import('@/components/dialog/SelectWinArticle')
                }
            },
            {
                path: '/dialog/video',
                name: 'SelectVideo',
                component: function () {
                    return import('@/components/dialog/SelectVideo')
                }
            },
            {
                path: '/template/list',
                name: 'template_list',
                component: function () {
                    return import('@/components/admin/template/TempList')
                }
            },
            {
                path: '/template/add',
                name: 'template_add',
                component: function () {
                    return import('@/components/admin/template/TempAdd')
                }
            },
            {
                path: '/template/publish',
                name: 'template_publish',
                component: function () {
                    return import('@/components/admin/template/Publish')
                }
            },
            {
                path: '/article/list',
                name: 'article_list',
                component: function () {
                    return import('@/components/admin/article/List')
                }
            },
            {
                path: '/jfcj/article/list',
                name: 'jfcj_article_list',
                component: function () {
                    return import('@/components/admin/article/JFCJList')
                }
            },
            {
                path: '/jfcj/article/detail',
                name: 'jfcj_article_detail',
                component: function () {
                    return import('@/components/admin/article/JFCJEditInfo')
                }
            },
            {
                path: '/article/detail',
                name: 'article_detail',
                component: function () {
                    return import('@/components/admin/article/DetailInfo')
                }
            },
            {
                path: '/article/edit',
                name: 'article_edit',
                component: function () {
                    return import('@/components/admin/article/EditInfo')
                }
            },
            {
                path: '/practitioners/list',
                name: 'PractitionersList',
                meta: {
                    title: '从业人员',
                },
                component: function () {
                    return import('@/components/admin/jfinfo/PractitionersList')
                }
            },
            {
                path: '/practitioners/add',
                name: 'PractitionersAdd',
                meta: {
                    title: '从业人员',
                },
                component: function () {
                    return import('@/components/admin/jfinfo/PractitionersAdd')
                }
            },
            {
                path: '/jfinfo/home',
                name: 'jfinfo_home',
                component: function () {
                    return import('@/components/admin/jfinfo/Home')
                }
            },
            {
                path: '/jfinfo/import',
                name: 'jfinfo_import',
                component: function () {
                    return import('@/components/admin/jfinfo/Import')
                }
            },
            {
                path: '/jfinfo/importedit',
                name: 'jfinfo_import_edit',
                component: function () {
                    return import('@/components/admin/jfinfo/ImportEdit')
                }
            },
            {
                path: '/jfinfo/banner',
                name: 'jfinfo_banner',
                component: function () {
                    return import('@/components/admin/jfinfo/Banner')
                }
            },
            {
                path: '/jfinfo/banner/add',
                name: 'jfinfo_banner_add',
                component: function () {
                    return import('@/components/admin/jfinfo/BannerAdd')
                }
            },
            {
                path: '/jfinfo/image',
                name: 'jfinfo_image',
                component: function () {
                    return import('@/components/admin/jfinfo/Image')
                }
            },
            {
                path: '/jfinfo/image/add',
                name: 'jfinfo_image_add',
                component: function () {
                    return import('@/components/admin/jfinfo/ImageAdd')
                }
            },
            {
                path: '/finance/calendar',
                name: 'finance_calendar',
                component: function () {
                    return import('@/components/admin/jfinfo/Calendar')
                }
            },
            {
                path: '/finance/calendar/add',
                name: 'finance_calendar_add',
                component: function () {
                    return import('@/components/admin/jfinfo/CalendarAdd')
                }
            },
            {
                path: '/jfinfo/adimg',
                name: 'setup_ad_img',
                component: function () {
                    return import('@/components/admin/jfinfo/AdImg')
                }
            },
            {
                path: '/jfinfo/ad_img/add',
                name: 'setup_ad_img_add',
                component: function () {
                    return import('@/components/admin/jfinfo/AdImgAdd')
                }
            },
            {
                path: '/jfinfo/thematic',
                name: 'setup_thematic',
                component: function () {
                    return import('@/components/admin/jfinfo/Thematic')
                }
            },
            {
                path: '/jfinfo/thematic/add',
                name: 'setup_thematic_add',
                component: function () {
                    return import('@/components/admin/jfinfo/ThematicAdd')
                }
            },
            {
                path: '/jfinfo/school/header',
                name: 'setup_school_header',
                component: function () {
                    return import('@/components/admin/jfinfo/SchoolHeader')
                }
            },
            {
                path: '/jfinfo/school/header/add',
                name: 'setup_school_header_add',
                component: function () {
                    return import('@/components/admin/jfinfo/SchoolHeaderAdd')
                }
            },
            {
                path: '/jfinfo/school/title',
                name: 'setup_school_title',
                component: function () {
                    return import('@/components/admin/jfinfo/SchoolTitle')
                }
            },
            {
                path: '/jfinfo/school/title/add',
                name: 'setup_school_title_add',
                component: function () {
                    return import('@/components/admin/jfinfo/SchoolTitleAdd')
                }
            },
            {
                path: '/jfinfo/school/article',
                name: 'setup_school_article',
                component: function () {
                    return import('@/components/admin/jfinfo/SchoolArticle')
                }
            },
            {
                path: '/jfinfo/school/article/add',
                name: 'setup_school_article_add',
                component: function () {
                    return import('@/components/admin/jfinfo/SchoolArticleAdd')
                }
            },
            {
                path: '/jfinfo/web/banner',
                name: 'jfinfo_web_banner',
                component: function () {
                    return import('@/components/admin/jfinfo/WebBanner')
                }
            },
            {
                path: '/jfinfo/web/banner/add',
                name: 'jfinfo_web_banner_add',
                component: function () {
                    return import('@/components/admin/jfinfo/WebBannerAdd')
                }
            },
            {
                path: '/jfinfo/article',
                name: 'jfinfo_article',
                component: function () {
                    return import('@/components/admin/jfinfo/Article')
                }
            },
            {
                path: '/jfinfo/artedit',
                name: 'jfinfo_artedit',
                component: function () {
                    return import('@/components/admin/jfinfo/ArticleEdit')
                }
            },
            {
                path: '/user/list',
                name: 'user_list',
                component: function () {
                    return import('@/components/admin/user/UserList')
                }
            },
            {
                path: '/category/list',
                name: 'category_list',
                component: function () {
                    return import('@/components/admin/jfinfo/CategoryList')
                }
            },
            ...organization,
            ...win,
            ...ihaogu,
            ...school,
            ...report,
            ...jfcap,
            ...team,
            ...jftech,
        ]
    },
]

const router = createRouter({
    //history: createWebHashHistory(),
    history: createWebHistory(),
    routes,
})
//导航守卫，可以在其中判断是否登录等
router.beforeEach((to, from, next) => {
    //to.href 预留写入session测试用的 路由
    if (to.meta.mustLogin) {
        // 需要鉴权的路由
        const token = localStorage.getItem("token") || false;
        if (token) {
            // 有token直接进入
            next();
        } else {
            // 跳转login
            router.push({path:'/wx_login'})
            /*next({
                name: 'wx_login',
                query: { ...to.query, toName: to.name }
            });*/
        }
    }else{
        next();
    }
});

router.afterEach((to) => {
    //console.log('from', from);
    if (to.meta.title) {
        document.title = to.meta.title;
    }
});

export default router
